export default __webpack_public_path__ + "static/summer_containers33-1e1a4d44ca2efe379215f3fb559bc17f.webp";